import { render, staticRenderFns } from "./NotificacoesDetalhe.vue?vue&type=template&id=3963933e&"
import script from "./NotificacoesDetalhe.vue?vue&type=script&lang=js&"
export * from "./NotificacoesDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./NotificacoesDetalhe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports